import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcab() {



    const cardData = {

      keyword: "Pune to Bhimashankar Cab",

headingDescription:
    "Rising Cab Service provides safe and affordable Pune to Bhimashankar Cab services for pilgrims, families, and tourists seeking a comfortable journey to one of the twelve Jyotirlingas in India. We offer one-way and round-trip taxi services with well-maintained Sedan, SUV, Innova Crysta, and Tempo Traveller vehicles driven by experienced chauffeurs. Our service ensures timely pickups, transparent pricing, and a smooth travel experience, making your spiritual and sightseeing trip convenient. Available 24x7, Rising Cab Service is a trusted choice for a hassle-free Bhimashankar journey.",

topPlaces: [
    {
        title: "Bhimashankar Jyotirlinga Temple",
        description:
            "Bhimashankar Temple is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and the primary attraction of the region. Nestled amidst the Sahyadri hills, the ancient temple features beautiful Nagara-style architecture and attracts thousands of devotees throughout the year. The peaceful surroundings and spiritual significance make it a must-visit pilgrimage destination."
    },
    {
        title: "Bhimashankar Wildlife Sanctuary",
        description:
            "Spread across the Western Ghats, Bhimashankar Wildlife Sanctuary is home to diverse flora and fauna, including the rare Indian Giant Squirrel. Nature lovers and wildlife enthusiasts can enjoy trekking trails, birdwatching, and scenic landscapes while exploring this protected forest area."
    },
    {
        title: "Hanuman Lake",
        description:
            "Hanuman Lake is a serene water body located near the Bhimashankar Temple and is surrounded by lush greenery. The peaceful environment makes it an ideal place for relaxation, photography, and spending quiet moments amidst nature after visiting the temple."
    },
    {
        title: "Gupt Bhimashankar",
        description:
            "Gupt Bhimashankar is a sacred spot believed to be the hidden origin of the Bhima River. According to local legends, the river emerges mysteriously from the forest here. Visitors enjoy the tranquil atmosphere and the short trek through scenic surroundings."
    },
    {
        title: "Nagphani Point",
        description:
            "Nagphani Point, also known as Cobra's Hood, is one of the highest viewpoints near Bhimashankar. The hilltop offers breathtaking views of the Sahyadri mountain ranges, deep valleys, and dense forests, making it a favorite destination for trekkers and photographers."
    },
    {
        title: "Sakshi Vinayak Temple",
        description:
            "Located close to the main temple, Sakshi Vinayak Temple is dedicated to Lord Ganesha. It is believed that devotees should visit this temple before and after seeking blessings at Bhimashankar Jyotirlinga, making it an important part of the pilgrimage."
    },
    {
        title: "Moksha Kund",
        description:
            "Moksha Kund is a sacred water tank associated with ancient Hindu mythology and spiritual rituals. Pilgrims visit the site for prayers and meditation, believing that the holy waters have religious significance and bring peace of mind."
    },
    {
        title: "Ahupe Ghat",
        description:
            "Ahupe Ghat is a picturesque mountain pass near Bhimashankar known for its stunning cliffs, waterfalls, and panoramic valley views. During the monsoon season, the area transforms into a lush green paradise, attracting nature lovers and adventure seekers."
    },
    {
        title: "Bombay Point",
        description:
            "Bombay Point near Bhimashankar offers magnificent views of the surrounding hills and forests. It is a peaceful location where visitors can enjoy sunrise and sunset while experiencing the natural beauty of the Western Ghats."
    },
    {
        title: "Kondhwal Waterfall",
        description:
            "Kondhwal Waterfall is a beautiful natural attraction located near Bhimashankar, especially popular during the rainy season. Surrounded by dense greenery and rocky landscapes, the waterfall provides a refreshing escape for families, trekkers, and photography enthusiasts."
    }
],



services: [
  {
    name: "Pune to Bhimashankar Taxi Fare",
    description: "Rising Cab Service offers transparent Pune to Bhimashankar Taxi Fare with affordable pricing based on vehicle type, distance, and trip duration. Our fares are designed to be budget-friendly while ensuring safe, comfortable, and reliable travel to the Bhimashankar Jyotirlinga temple with professional drivers and AC vehicles."
  },
  {
    name: "Pune to Bhimashankar Cab Fare",
    description: "Check Pune to Bhimashankar Cab Fare with Rising Cab Service for clear, upfront pricing with no hidden charges. We provide competitive rates for sedans, SUVs, and premium vehicles, making your pilgrimage journey economical and stress-free with smooth highway travel and doorstep pickup."
  },
  {
    name: "Taxi from Pune to Bhimashankar",
    description: "Book Taxi from Pune to Bhimashankar with Rising Cab Service for a safe and comfortable pilgrimage ride to the sacred Bhimashankar Jyotirlinga temple. Enjoy well-maintained AC cars, experienced drivers familiar with ghat roads, flexible pickup timing, and 24x7 booking support for a hassle-free journey."
  },
  {
    name: "Pune to Bhimashankar Cab Price",
    description: "Get the best Pune to Bhimashankar Cab Price with affordable packages designed for solo travelers, families, and groups. Our pricing includes fuel, driver allowance, and tolls (as per package), ensuring complete transparency and a smooth travel experience without surprise costs."
  },
  {
    name: "Bhimashankar Cab from Pune",
    description: "Book Bhimashankar Cab from Pune for a peaceful pilgrimage journey with comfortable AC vehicles, professional chauffeurs, and safe driving through scenic mountain routes. Ideal for devotees visiting the Jyotirlinga temple with flexible one-way and round-trip options."
  },
  {
    name: "Cab Service from Pune to Bhimashankar",
    description: "Rising Cab Service provides reliable Cab Service from Pune to Bhimashankar with experienced drivers, clean vehicles, and smooth travel arrangements. Perfect for family trips, religious visits, and one-day temple tours with complete comfort and safety assurance."
  },
  {
    name: "Pune to Bhimashankar Cab Booking",
    description: "Easy Pune to Bhimashankar Cab Booking system for instant reservations with multiple vehicle choices including Sedan, SUV, Innova Crysta, and Tempo Traveller. Enjoy quick confirmation, 24x7 support, and flexible scheduling for your pilgrimage travel needs."
  },
  {
    name: "Pune to Bhimashankar Cab Charges",
    description: "Know Pune to Bhimashankar Cab Charges in advance with our transparent pricing model. We offer affordable rates based on distance and vehicle type, ensuring cost-effective travel without compromising comfort, safety, or service quality."
  },
  {
    name: "Pune to Bhimashankar Cab Package",
    description: "Choose Pune to Bhimashankar Cab Package for a complete one-day or round-trip pilgrimage experience. Packages include pickup, temple visit waiting time, return journey, and flexible travel options designed for families and group devotees."
  },
  {
    name: "Pune to Bhimashankar Taxi Service",
    description: "Reliable Pune to Bhimashankar Taxi Service for safe, comfortable, and timely travel to the Bhimashankar Jyotirlinga temple. We provide professional drivers, AC vehicles, and 24x7 availability for a smooth pilgrimage experience."
  },
  {
    name: "Pune to Bhimashankar Temple Cab Fare",
    description: "Affordable Pune to Bhimashankar Temple Cab Fare designed for devotees visiting the sacred Jyotirlinga. Our fare structure ensures transparency and comfort with well-maintained vehicles and experienced drivers for mountain routes."
  },
  {
    name: "Pune to Bhimashankar Tempo Traveller",
    description: "Book Pune to Bhimashankar Tempo Traveller for large groups and family pilgrimages. Spacious seating, comfortable interiors, and experienced drivers make group travel to Bhimashankar safe and enjoyable."
  },
  {
    name: "Taxi Service from Pune to Bhimashankar",
    description: "Trusted Taxi Service from Pune to Bhimashankar offering smooth, safe, and reliable travel for devotees. Enjoy flexible booking options, clean AC cars, and professional chauffeurs for a peaceful journey."
  },
  {
    name: "Pune Airport to Bhimashankar Jyotirlinga",
    description: "Direct Pune Airport to Bhimashankar Jyotirlinga cab service for travelers arriving by flight. We provide instant pickup, luggage assistance, and comfortable long-distance travel straight to the temple without delays."
  },
  {
    name: "Jyotirlinga Darshan Package from Pune",
    description: "Complete Jyotirlinga Darshan Package from Pune covering Bhimashankar pilgrimage with pickup, temple visit, waiting time, and return journey. Ideal for devotees seeking a well-organized spiritual travel experience."
  },
  {
    name: "Pune to Bhimashankar Innova Crysta",
    description: "Premium Pune to Bhimashankar Innova Crysta service for families and groups seeking extra comfort and space. Enjoy luxury seating, smooth ride quality, and professional drivers for long-distance pilgrimage travel."
  },
  {
    name: "Pune to Bhimashankar Swift Dzire Cab",
    description: "Affordable Pune to Bhimashankar Swift Dzire Cab service ideal for small families and solo travelers. Enjoy budget-friendly pricing, AC comfort, and safe driving through scenic ghat routes."
  },
  {
    name: "Pimpri Chinchwad to Bhimashankar Cab",
    description: "Reliable Pimpri Chinchwad to Bhimashankar Cab service with doorstep pickup, experienced drivers, and comfortable vehicles for a smooth pilgrimage journey to the Jyotirlinga temple."
  },
  {
    name: "Pune to Bhimashankar Tour Package",
    description: "Custom Pune to Bhimashankar Tour Package offering complete travel arrangements including pickup, sightseeing, temple visit, waiting time, and return journey for a hassle-free pilgrimage experience."
  },
  {
    name: "One Day Trip to Bhimashankar from Pune",
    description: "Enjoy One Day Trip to Bhimashankar from Pune with early morning pickup, comfortable travel, temple darshan, and same-day return. Perfect for quick and fulfilling spiritual journeys."
  }
],

tableData: [
  ["Pune to Bhimashankar Taxi Fare", "Pune to Bhimashankar Cab Fare"],
  ["Taxi from Pune to Bhimashankar", "Pune to Bhimashankar Cab Price"],
  ["Bhimashankar Cab from Pune", "Cab Service from Pune to Bhimashankar"],
  ["Pune to Bhimashankar Cab Booking", "Pune to Bhimashankar Cab Charges"],
  ["Pune to Bhimashankar Cab Package", "Pune to Bhimashankar Taxi Service"],
  ["Pune to Bhimashankar Tempo Traveller", "Taxi Service from Pune to Bhimashankar"],
  ["Pune Airport to Bhimashankar Jyotirlinga", "Jyotirlinga Darshan Package from Pune"],
  ["Pune to Bhimashankar Innova Crysta", "Pune to Bhimashankar Swift Dzire Cab"],
  ["Pimpri Chinchwad to Bhimashankar Cab", "Pune to Bhimashankar Tour Package"],
  ["One Day Trip to Bhimashankar from Pune", "Pune to Bhimashankar Cab Service"]
],



     whychoose: [
    {
        WhyChooseheading: "Dedicated Pune to Bhimashankar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Bhimashankar cab services for pilgrims, families, tourists, and devotees seeking a comfortable spiritual journey."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Temple Travel",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, and spacious vehicles that ensure a smooth and relaxing journey to Bhimashankar."
    },
    {
        WhyChooseheading: "Experienced Drivers for Ghat Routes",
        WhyChoosedescription: "Our professional drivers are familiar with the Pune to Bhimashankar route, including hill roads and temple access points, ensuring safe travel."
    },
    {
        WhyChooseheading: "Affordable Bhimashankar Cab Packages",
        WhyChoosedescription: "Rising Cab Service offers budget-friendly Pune to Bhimashankar taxi packages with transparent pricing and no hidden charges."
    },
    {
        WhyChooseheading: "One Way and Round Trip Options",
        WhyChoosedescription: "Customers can choose from one-way cab services, same-day return trips, or customized round-trip packages based on their travel plans."
    },
    {
        WhyChooseheading: "24/7 Cab Booking Assistance",
        WhyChoosedescription: "Our booking team is available round the clock to help customers schedule Pune to Bhimashankar cab services at their convenience."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune",
        WhyChoosedescription: "We provide pickup services from Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Pune Airport, and all major Pune locations."
    },
    {
        WhyChooseheading: "Perfect for Jyotirlinga Darshan",
        WhyChoosedescription: "Our cab service is ideal for devotees visiting Bhimashankar Jyotirlinga and nearby religious destinations comfortably and safely."
    }
]
};

const faqData = [
    {
        question: "How far is Bhimashankar from Pune?",
        answer: "Bhimashankar is located approximately 110 to 125 kilometers from Pune, depending on the pickup location and travel route."
    },
    {
        question: "Do you provide one-way cab service from Pune to Bhimashankar?",
        answer: "Yes, Rising Cab Service offers both one-way and round-trip cab services from Pune to Bhimashankar."
    },
    {
        question: "Which vehicles are available for Bhimashankar travel?",
        answer: "We provide Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and larger vehicles for group travel."
    },
    {
        question: "Can I book a same-day return trip to Bhimashankar?",
        answer: "Yes, customers can book same-day return cab packages for Bhimashankar Jyotirlinga Darshan."
    },
    {
        question: "Is Bhimashankar cab service available 24 hours?",
        answer: "Yes, our Pune to Bhimashankar cab booking service is available 24/7."
    },
    {
        question: "Are your drivers familiar with the Bhimashankar route?",
        answer: "Yes, our experienced drivers regularly operate on the Pune to Bhimashankar route and know the road conditions well."
    },
    {
        question: "Can families and senior citizens travel comfortably?",
        answer: "Yes, our vehicles are suitable for families, children, and senior citizens seeking a comfortable pilgrimage journey."
    },
    {
        question: "Do you offer pickup from Pune Airport?",
        answer: "Yes, we provide pickup services from Pune Airport, Railway Station, hotels, homes, and all major Pune locations."
    },
    {
        question: "Can I include nearby sightseeing places during the trip?",
        answer: "Yes, customized itineraries can include nearby attractions and sightseeing spots around Bhimashankar."
    },
    {
        question: "How can I book a Pune to Bhimashankar Cab?",
        answer: "You can easily book your cab through phone, WhatsApp, or online booking with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prashant Shinde",
        feedback:
            "Our Bhimashankar Jyotirlinga trip was comfortable and well-managed. The driver was punctual, the vehicle was clean, and the overall travel experience was excellent.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Anjali Kulkarni",
        feedback:
            "Rising Cab Service made our pilgrimage journey smooth and stress-free. The cab was comfortable, and the driver ensured a safe trip throughout the route.",
        rating: 5
    }
];























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];














const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Bhimashankar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-bhimashankar-cab.jpg",
"description": "Book Pune to Bhimashankar Cab Service with Rising Cab Service for comfortable and affordable travel. Enjoy reliable taxi service, professional drivers, flexible cab packages, and hassle-free temple visits to Bhimashankar Jyotirlinga.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-bhimashankar-cab"
}
};





    return (
        <div>
<Helmet>
  <title>Pune to Bhimashankar Cab Service | Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Bhimashankar Cab Service at affordable rates. Comfortable taxi service with experienced drivers for one-way, round-trip, temple visits, and family travel from Pune to Bhimashankar."
/>

<meta
 name="keywords"
 content="pune to bhimashankar taxi fare, pune to bhimashankar cab fare, taxi from pune to bhimashankar, Pune to bhimashankar cab price, bhimashankar cab from pune, book cab from pune to bhimashankar, cab service from pune to bhimashankar, Pune to bhimashankar by cab charges, Pune to bhimashankar cab booking, Pune to bhimashankar cab charges, Pune to bhimashankar cab package, pune to bhimashankar cab service, Pune to Bhimashankar taxi service, Bhimashankar temple cab from Pune, Pune Bhimashankar round trip cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankarcab;